<template>
  <span>{{ params.nombreCampo }}</span>
</template>

<script>
export default {
  name: 'CabeceraCuotaAnterior',
};
</script>